const verification = {
  // Page titles
  title: 'Identity Verification',
  subtitle: 'Complete verification to access all features',

  // Status and progress
  statusTitle: 'Verification Status',
  progress: 'Progress',
  stepCompleted: 'Completed',
  startVerification: 'Start Verification',
  continueVerification: 'Continue Verification',
  verificationComplete: 'Verification Complete',
  verificationCompleteDesc: 'Your account has been verified and you are now eligible for the Verified Broker badge',
  comingSoon: 'Coming Soon',

  // Badge labels
  badges: {
    verified: 'Verified Broker',
    verifiedTooltip: 'This broker has been verified and meets quality and compliance standards',
    gold: 'Gold Broker',
    goldTooltip: 'A distinguished broker with high ratings and excellent performance record',
    platinum: 'Platinum Broker',
    platinumTooltip: 'Highest level of distinction with a proven track record of success',
    company: 'Verified Company',
    companyTooltip: 'A licensed and verified real estate company',
  },

  // Requirements
  requirementsMet: 'requirements met',
  requirements: 'Requirements',
  benefits: 'Benefits',
  achieved: 'Achieved',
  currentGoal: 'Current Goal',

  // Nafath verification
  nafath: {
    title: 'Nafath Verification',
    description: 'Verify your identity through Nafath app',
    initiate: 'Start Verification',
    waitingTitle: 'Waiting for Verification',
    waitingDescription: 'Open Nafath app and complete the verification',
    codeLabel: 'Verification Code',
    scanQR: 'Or scan QR code',
    verified: 'Successfully Verified',
    verifiedDescription: 'Your identity has been verified through Nafath',
    failed: 'Verification Failed',
    failedDescription: 'We could not verify your identity. Please try again.',
    expired: 'Session Expired',
    expiredDescription: 'The verification session has expired. Please try again.',
    cancel: 'Cancel',
    retry: 'Retry',
    apiPending: 'Nafath verification will be activated soon. We are working on connecting the service.',
    status: {
      not_started: 'Not Started',
      pending: 'Pending',
      completed: 'Completed',
      failed: 'Failed',
      expired: 'Expired',
    },
  },

  // FAL license
  fal: {
    title: 'Link FAL License',
    description: 'Link your real estate brokerage license',
    licenseNumber: 'FAL License Number',
    licenseNumberPlaceholder: 'Enter license number',
    link: 'Link License',
    unlink: 'Unlink',
    linked: 'License Linked',
    linkedDescription: 'Your FAL license is linked to your account',
    notLinked: 'No License Linked',
    notLinkedDescription: 'Link your FAL license to advertise properties',
    verifying: 'Verifying license...',
    invalid: 'Invalid License',
    invalidDescription: 'License number is incorrect or inactive',
    expired: 'License Expired',
    expiredDescription: 'Your license has expired. Please renew it.',
    details: {
      holderName: 'License Holder Name',
      type: 'License Type',
      issueDate: 'Issue Date',
      expiryDate: 'Expiry Date',
      activities: 'Licensed Activities',
    },
    status: {
      not_linked: 'Not Linked',
      pending: 'Verifying',
      active: 'Active',
      expired: 'Expired',
      invalid: 'Invalid',
    },
  },

  // Owner verification wizard
  owner: {
    title: 'Property Ownership Verification',
    description: 'Complete the following questions to verify your property ownership',
    startVerification: 'Start Verification',
    continueVerification: 'Continue Verification',
    step: 'Step',
    of: 'of',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit for Review',
    saveProgress: 'Save Progress',

    // Question categories
    categories: {
      consent: 'Representation Consent',
      identity: 'Identity Verification',
      ownership: 'Ownership Proof',
      authorization: 'Official Authorization',
      propertyDetails: 'Property Details',
      contact: 'Contact Information',
      declarations: 'Legal Declarations',
      license: 'Advertisement License',
      signature: 'Electronic Signature',
    },

    // Common question labels
    questions: {
      consent: 'Do you agree for the platform to represent you as a real estate broker?',
      representationType: 'Type of representation required',
      verifyNafath: 'Verify through Nafath',
      isOwner: 'Are you the registered owner on the deed?',
      deedType: 'Deed type',
      deedNumber: 'Deed number',
      isMortgaged: 'Is the property mortgaged?',
      hasDisputes: 'Are there any legal disputes on the property?',
      authorizationType: 'Authorization type',
      authorizationDuration: 'Authorization duration',
      listingType: 'Listing type',
      propertyType: 'Property type',
      location: 'Property location',
      price: 'Asking price',
      isPriceNegotiable: 'Is the price negotiable?',
      specialConditions: 'Special conditions',
      contactReceiver: 'Who receives inquiries?',
      shareData: 'Do you agree to share your data with interested parties?',
      declareLegalOwner: 'I declare that I am the legal owner',
      declareAuthorization: 'I authorize the platform officially',
      declareDataAccuracy: 'I declare all information is accurate',
      declareResponsibility: 'I accept responsibility for any false information',
      consentLicense: 'Do you agree to issue the ad license under the platform as broker?',
      signContract: 'Sign the brokerage contract',
    },

    // Options
    options: {
      representationType: {
        adOnly: 'Advertisement only',
        adAndMarketing: 'Advertisement + Marketing',
        full: 'Advertisement + Marketing + Receive inquiries',
      },
      deedType: {
        electronic: 'Electronic',
        paper: 'Paper',
      },
      authorizationType: {
        absher: 'Electronic authorization via Absher',
        contract: 'Electronic brokerage contract',
      },
      authorizationDuration: {
        oneMonth: '1 month',
        threeMonths: '3 months',
        sixMonths: '6 months',
      },
      listingType: {
        sale: 'Sale',
        rent: 'Rent',
      },
      contactReceiver: {
        platform: 'Platform',
        owner: 'Owner',
      },
    },

    // Status
    status: {
      not_started: 'Not Started',
      in_progress: 'In Progress',
      pending_review: 'Pending Review',
      approved: 'Approved',
      rejected: 'Rejected',
    },

    // Messages
    progressSaved: 'Your progress has been saved',
    submittedForReview: 'Your request has been submitted for review',
    reviewTime: 'Your request will be reviewed within 24-48 hours',
  },

  // General
  steps: {
    identity: 'Identity Verification',
    license: 'FAL License',
    completed: 'Completed',
  },
  verificationRequired: 'Verification Required',
  verificationRequiredDescription: 'You must complete verification to access this feature',
  completeVerification: 'Complete Verification',
};

export default verification;
